import React from 'react'
import Footer from './common/Footer'
import Header from './common/Header'

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBWXUKNFl53bFsQGT1dvW64l6TAxxSlH98",
  authDomain: "x-website-b20d4.firebaseapp.com",
  projectId: "x-website-b20d4",
  storageBucket: "x-website-b20d4.appspot.com",
  messagingSenderId: "591056002972",
  appId: "1:591056002972:web:c7e58d1b8e7d8adf83b259",
  measurementId: "G-Y1KWCB4K3L"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

function Layout({children}) {
  return (
    <>
     <Header/> 
     {children}
     <Footer/>  
    </>
  )
}

export default Layout